import { EventReportFilter } from '@contexts/event-report/event-report-context.type';
import { EventAttendeesStatsResponse, EventSalesStatsParams } from '@domain/event-report';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';

export const createEventSalesStatsKey = (eventId: string | undefined, params: EventReportFilter | undefined) => {
  return [QUERY_KEYS.eventAttendeesStats, eventId, params];
};

const getAttendeesStats = async ({ eventId, params }: EventSalesStatsParams) => {
  const queryParams = paramsSerializer({ ...params });
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/events/${eventId}/attendees-stats-grouped-by-date?${queryParams}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEventAttendeesStats = ({ eventId, params, options }: EventSalesStatsParams) => {
  return useGenericQuery<EventAttendeesStatsResponse, RequestError>(
    createEventSalesStatsKey(eventId, params),
    () => getAttendeesStats({ eventId, params }),
    {
      ...options,
    }
  );
};
